// import vue-router
import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@sto/auth.store'
import { useSystemStore } from '@sto/system.store'
import { useCommentStore } from '@sto/comment.store'

export const router = createRouter({
    // history mode
    history: createWebHistory(),
    // routes
    routes: [
        {
            path: '/',
            component: () => import('../screens/AuthLayout.vue'),
            children: [
                {
                    path: '/',
                    name: 'public.index',
                    component: () => import('../screens/PublicIndexScreen.vue'),
                    meta: {
                        title: 'Home',
                        protected: false,
                    }
                },
                {
                    path: '/login',
                    name: 'auth.login',
                    component: () => import('../screens/AuthLoginScreen.vue'),
                    meta: {
                        title: 'Log in',
                        protected: false,
                    }
                },
                {
                    path: '/maintenance-mode/:access_password',
                    name: 'auth.maintenance_mode',
                    component: () => import('../screens/AuthMaintenanceModeAccessScreen.vue'),
                    meta: {
                        title: 'Log in',
                        protected: false,
                    }
                },
                {
                    path: '/password',
                    name: 'password.index',
                    component: import('../screens/AuthForgotPasswordScreen.vue'),
                    meta: {
                        title: 'Request a Password Reset',
                        protected: false,
                    }
                },
                {
                    path: '/password/forgotten',
                    name: 'password.forgotten',
                    component: () => import('../screens/AuthForgotPasswordScreen.vue'),
                    meta: {
                        title: 'Request a Password Reset',
                        protected: false,
                    }
                },
                {
                    path: '/password/reset/:token',
                    name: 'password.reset',
                    component: () => import('../screens/AuthResetPasswordScreen.vue'),
                    meta: {
                        title: 'Reset Password',
                        protected: false,
                    }
                }
            ]
        },
        /**
         * invite routes
         */
        {
            path: '/invitation',
            component: () => import('../screens/AuthLayout.vue'),
            children: [
                {
                    path: '/invitation/:token/redeem',
                    name: 'invite.redeem',
                    component: () => import('../screens/InviteRedeemScreen.vue'),
                    meta: {
                        title: 'Redeem an Invition',
                        protected: false,
                    }
                },
            ]
        },
        /**
         * public display
         */
        {
            path: '/d',
            component: () => import('../screens/PublicLayout.vue'),
            children: [
                {
                    path: '/d/auctioneer/:auctioneer_id/lot/:lot_id',
                    name: 'display.lot',
                    component: () => import('@scr/DisplayLotScreen.vue'),
                    meta: {
                        title: 'lot',
                        protected: false,
                    }
                },
            ]
        },
        {
            path: '/app',
            component: () => import('../screens/AppLayout.vue'),
            children: [
                {
                    path: '/app',
                    name: 'user.dashboard',
                    component: () => import('../screens/UserDashboardScreen.vue'),
                    meta: {
                        title: 'Dashboard',
                        protected: true,
                    }
                },
                /**********************************************************************
                 * Loans
                 **********************************************************************/
                {
                    path: '/app/loans',
                    name: 'loan.index',
                    component: () => import('../screens/LoanIndexScreen.vue'),
                    meta: {
                        title: 'Loans',
                        protected: true,
                    }
                },
                {
                    path: '/app/loans/:loan_id',
                    name: 'loan.view',
                    component: () => import('../screens/LoanViewScreen.vue'),
                    meta: {
                        title: 'Loan View',
                        protected: true,
                        breadcrumbs: [
                            { name: 'loan.index', label: 'Loans' }
                        ]
                    }
                },
                {
                    path: '/app/loans/:loan_id/application',
                    name: 'loan.application',
                    component: () => import('../screens/LoanApplicationScreen.vue'),
                    meta: {
                        title: 'Loan Application',
                        protected: true,
                        breadcrumbs: [
                            { name: 'loan.index', label: 'Loans' }
                        ]
                    }
                },
                /**********************************************************************
                 * Vehicles
                 **********************************************************************/
                 {
                    path: '/app/vehicles/:vehicle_id/create',
                    name: 'vehicle.create',
                    component: () => import('../screens/VehicleCreateScreen.vue'),
                    meta: {
                        title: 'Add a vehicle',
                        protected: true,
                    }
                },
                {
                    path: '/app/vehicles-dep',
                    name: 'vehicle.index',
                    component: () => import('../screens/VehicleIndexScreen.vue'),
                    meta: {
                        title: 'Vehicle Inventory',
                        protected: true,
                    }
                },
                {
                    path: '/app/vehicles',
                    name: 'vehicle.user.index',
                    component: () => import('../screens/UserVehicleIndexScreen.vue'),
                    meta: {
                        title: 'My Vehicles',
                        protected: true,
                    }
                },
                {
                    path: '/app/vehicles/v2',
                    name: 'vehicle.user.v2.index',
                    component: () => import('../screens/UserVehicleV2IndexScreen.vue'),
                    meta: {
                        title: 'My Vehicles (v2)',
                        protected: true,
                    }
                },
                {
                    path: '/app/organisations/:organisation_id?/vehicles',
                    name: 'organisation.vehicle.list',
                    component: () => import('../screens/OrganisationVehiclesListScreen.vue'),
                    meta: {
                        title: 'Organisation Vehicles',
                        protected: true,
                    }
                },
                {
                    path: '/app/organisations/:organisation_id?/vehicles/:vehicle_id',
                    name: 'organisation.vehicle.view',
                    component: () => import('../screens/UserVehicleViewScreen.vue'),
                    meta: {
                        title: 'Organisation Vehicle',
                        protected: true,
                    }
                },
                // TODO deprecate...
                {
                    path: '/app/organisations/:organisation_id?/assets/:asset_id/send-to-auction',
                    name: 'organisation.asset.transfer_vehicle_dealership_to_auctioneer',
                    component: () => import('../screens/OrganisationVehicleDealershipToAuctioneerScreen.vue'),
                    meta: {
                        title: 'Asset Transfer Orders',
                        protected: true,
                    }
                },
                // TODO: deprecate...
                {
                    path: '/app/organisations/:organisation_id?/assets/:asset_id/transfer-order/:transfer_order_id/review',
                    name: 'organisation.asset.transfer_order.review',
                    component: () => import('../screens/ReviewTransferOrderScreen.vue'),
                    meta: {
                        title: 'Review Asset Transfer Order',
                        protected: true,
                    }
                },
                {
                    path: '/app/vehicles/:vehicle_id',
                    name: 'vehicle.view',
                    component: () => import('../screens/UserVehicleViewScreen.vue'),
                    meta: {
                        title: 'Vehicle',
                        protected: true,
                    }
                },
                /**********************************************************************
                 * General Items
                 **********************************************************************/
                {
                    path: '/app/items',
                    name: 'items.index',
                    component: () => import('../screens/GeneralItemIndexScreen.vue'),
                    meta: {
                        title: 'My Items',
                        protected: true,
                    }
                },
                {
                    path: '/app/items/:asset_id/create',
                    name: 'items.create',
                    component: () => import('../screens/GeneralItemCreateScreen.vue'),
                    meta: {
                        title: 'Create an Item',
                        protected: true,
                    }
                },
                {
                    path: '/app/items/:asset_id',
                    name: 'items.view',
                    component: () => import('../screens/GeneralItemViewScreen.vue'),
                    meta: {
                        title: 'View an Item',
                        protected: true,
                    }
                },
                /**********************************************************************
                 * Transfer Orders
                 **********************************************************************/
                {
                    path: '/app/transfer-orders',
                    name: 'transfer_order.index',
                    component: () => import('../screens/TransferOrderIndexScreen.vue'),
                    meta: {
                        title: 'Transfer Orders',
                        protected: true,
                    }
                },
                {
                    path: '/app/my-transfers-in',
                    name: 'transfers.in',
                    component: () => import('../screens/TransferInScreen.vue'),
                    meta: {
                        title: 'Transfers In',
                        protected: true,
                    }
                },
                {
                    path: '/app/my-transfers-out',
                    name: 'transfers.out',
                    component: () => import('../screens/TransferOutScreen.vue'),
                    meta: {
                        title: 'Transfers Out',
                        protected: true,
                    }
                },
                {
                    path: '/app/assets/:asset_id/transfer-order/:transfer_order_id',
                    name: 'transfer_order.view',
                    component: () => import('../screens/TransferOrderScreen.vue'),
                    meta: {
                        title: 'Asset Transfer Order',
                        protected: true,
                    }
                },
                // possibly deprecate
                {
                    path: '/app/transfer-request/:transfer_request_id/send-to-auction',
                    name: 'transfer_request.create',
                    component: () => import('../screens/TransferRequestCreateScreen.vue'),
                    meta: {
                        title: 'Arrange Collection or Delivery',
                        protected: true,
                    }
                },
                {
                    /**
                     * view transfer request through the scope of a specified organisation
                     */
                    path: '/app/transfer-request/:transfer_request_id',
                    name: 'transfer_request.view',
                    component: () => import('../screens/TransferRequestViewScreen.vue'),
                    meta: {
                        title: 'View Transfer Request',
                        protected: true,
                    }
                },
                {
                    /**
                     * edit transfer request through the scope of a specified organisation
                     */
                    path: '/app/transfer-request/:transfer_request_id/edit',
                    name: 'transfer_request.edit',
                    component: () => import('../screens/TransferRequestEditScreen.vue'),
                    meta: {
                        title: 'Edit Transfer Request',
                        protected: true,
                    }
                },
                {
                    // http://auction365.test:5173/app/transfer-request/1/destination-review
                    path: '/app/transfer-request/:transfer_request_id/destination-review',
                    name: 'transfer_request.destination_review',
                    component: () => import('../screens/TransferRequestDestinationReviewScreen.vue'),
                    meta: {
                        title: 'Review Transfer Request',
                        protected: true,
                    }
                },
                {
                    // http://auction365.test:5173/app/transfer-request/1/assets/1,2,3/schedule-collection
                    path: '/app/transfer-request/:transfer_request_id/assets/:asset_ids/schedule-collection',
                    name: 'transfer_request.schedule_collection',
                    component: () => import('../screens/TransferOrderScheduleCollectionScreen.vue'),
                    meta: {
                        title: 'Schedule Collection',
                        protected: true,
                    }
                },
                {
                    // http://auction365.test:5173/app/transfer-request/1/assets/1,2,3/arrange-delivery
                    path: '/app/transfer-request/:transfer_request_id/assets/:asset_ids/arrange-delivery',
                    name: 'transfer_request.arrange_delivery',
                    component: () => import('../screens/TransferOrderArrangeDeliveryScreen.vue'),
                    meta: {
                        title: 'Arrange Delivery',
                        protected: true,
                    }
                },
                {
                    path: '/app/send-vehicles-to-auction',
                    name: 'vehicle.send_to_auction',
                    component: () => import('../screens/SendVehiclesToAuctionScreen.vue'),
                    meta: {
                        title: 'Send Vehicles to Auction',
                        protected: true
                    }
                },
                /**********************************************************************
                 * Sales
                 **********************************************************************/
                {
                    path: '/app/sales',
                    name: 'sales.index',
                    component: () => import('../screens/SalesIndexScreen.vue'),
                    meta: {
                        title: 'Sales',
                        protected: true,
                    }
                },
                {
                    path: '/app/sales/settings',
                    name: 'sales.settings',
                    component: () => import('../screens/SalesSettingsScreen.vue'),
                    meta: {
                        title: 'Sales Settings',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' }
                        ]
                    }
                },
                {
                    path: '/app/sales/types/create',
                    name: 'sales.types.create',
                    component: () => import('../screens/SalesTypeCreateScreen.vue'),
                    meta: {
                        title: 'New Sale Type',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', params: { activate_tab: 'sale_types' }, label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/sections/create',
                    name: 'sales.sections.create',
                    component: () => import('../screens/SalesSectionCreateScreen.vue'),
                    meta: {
                        title: 'New Sale Section',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', params: { activate_tab: 'sale_sections' }, label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/codes/create',
                    name: 'sales.codes.create',
                    component: () => import('../screens/SalesCodeCreateScreen.vue'),
                    meta: {
                        title: 'New Sale Code',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/custom-fields/create',
                    name: 'sales.custom_fields.create',
                    component: () => import('../screens/SalesCustomFieldCreateScreen.vue'),
                    meta: {
                        title: 'New Custom Field',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/custom-fields/:feature_field_id/update',
                    name: 'sales.custom_fields.update',
                    component: () => import('../screens/SalesCustomFieldUpdateScreen.vue'),
                    meta: {
                        title: 'Update Custom Field',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/codes/:sale_code_id',
                    name: 'sales.codes.view',
                    component: () => import('../screens/SalesCodeViewScreen.vue'),
                    meta: {
                        title: 'Sale Code',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/codes/:sale_code_id/update',
                    name: 'sales.codes.update',
                    component: () => import('../screens/SalesCodeUpdateScreen.vue'),
                    meta: {
                        title: 'Update Sale Code',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/sections/:sale_section_id',
                    name: 'sales.sections.view',
                    component: () => import('../screens/SalesSectionViewScreen.vue'),
                    meta: {
                        title: 'Sale Section',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/sections/:sale_section_id/update',
                    name: 'sales.sections.update',
                    component: () => import('../screens/SalesSectionUpdateScreen.vue'),
                    meta: {
                        title: 'Update Sale Section',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/types/:sale_type_id',
                    name: 'sales.types.view',
                    component: () => import('../screens/SalesTypeViewScreen.vue'),
                    meta: {
                        title: 'Sale Type',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/types/:sale_type_id/update',
                    name: 'sales.types.update',
                    component: () => import('../screens/SalesTypeUpdateScreen.vue'),
                    meta: {
                        title: 'Update Sale Type',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                            { name: 'sales.settings', label: 'Sales Settings' }
                        ]
                    }
                },
                {
                    path: '/app/sales/create',
                    name: 'sales.new.create',
                    component: () => import('../screens/SalesCreateScreen.vue'),
                    meta: {
                        title: 'Add a new Sale',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                        ]
                    }
                },
                {
                    path: '/app/sales/:sale_id/configure',
                    name: 'sales.new.configure',
                    component: () => import('../screens/SalesConfigureScreen.vue'),
                    meta: {
                        title: 'Add a new Sale',
                        protected: true,
                        breadcrumbs: [
                            { name: 'sales.index', label: 'Sales' },
                        ]
                    }
                },
                {
                    path: '/app/sales/:sale_id',
                    name: 'sales.view',
                    component: () => import('../screens/SalesShowScreen.vue'),
                    meta: {
                        title: 'The Sale',
                        protected: true,
                    }
                },
                {
                    path: '/app/sales/:sale_id/edit',
                    name: 'sales.edit',
                    component: () => import('../screens/SalesEditScreen.vue'),
                    meta: {
                        title: 'Edit Sale',
                        protected: true,
                    }
                },
                {
                    path: '/app/sales/:sale_id/add-lots',
                    name: 'sales.add_lots',
                    component: () => import('../screens/SalesAddLotsScreen.vue'),
                    meta: {
                        title: 'Add lots to a sale',
                        protected: true,
                    }
                },
                {
                    path: '/app/sales/:sale_id/lots/:lot_id',
                    name: 'sales.lots.show',
                    component: () => import('../screens/LotsShowScreen.vue'),
                    meta: {
                        title: 'The lot',
                        protected: true,
                    }
                },
                {
                    path: '/app/sales/:sale_id/lots/:lot_id/manage',
                    name: 'sales.lots.manage',
                    component: () => import('../screens/LotsManageScreen.vue'),
                    meta: {
                        title: 'Manage the lot',
                        protected: true,
                    }
                },

                /**********************************************************************
                 * Accounts
                 **********************************************************************/
                {
                    path: '/app/accounts',
                    name: 'accounts.index',
                    component: () => import('../screens/AccountsIndexScreen.vue'),
                    meta: {
                        title: 'Accounts',
                        protected: true,
                    }
                },
                {
                    path: '/app/accounts/create',
                    name: 'accounts.create',
                    component: () => import('../screens/AccountsCreateScreen.vue'),
                    meta: {
                        title: 'Add New Account',
                        protected: true,
                        breadcrumbs: [
                            { name: 'accounts.index', label: 'All Accounts' }
                        ]
                    }
                },
                {
                    path: '/app/accounts/test',
                    name: 'accounts.test-assign',
                    component: () => import('../screens/TestAccountAssignScreen.vue'),
                    meta: {
                        title: 'Test Assign Account',
                        protected: true
                    }
                },
                {
                    path: '/app/auctioneer/:auctioneer_id/accounts/:account_id/update',
                    name: 'accounts.update',
                    component: () => import('../screens/AccountsUpdateScreen.vue'),
                    meta: {
                        title: 'Update Account',
                        protected: true,
                    }
                },
                {
                    path: '/app/accounts/:account_id',
                    name: 'accounts.show',
                    component: () => import('../screens/AccountsShowScreen.vue'),
                    meta: {
                        title: 'Account',
                        protected: true
                    }
                },
                /**********************************************************************
                 * Buyers
                 **********************************************************************/
                {
                    path: '/app/buyers',
                    name: 'buyers.index',
                    component: () => import('../screens/BuyerIndexScreen.vue'),
                    meta: {
                        title: 'Buyers',
                        protected: true,
                    }
                },
                {
                    path: '/app/buyers/create',
                    name: 'buyers.create',
                    component: () => import('../screens/BuyerCreateScreen.vue'),
                    meta: {
                        title: 'New Buyer',
                        protected: true,
                        breadcrumbs: [
                            { name: 'buyers.index', label: 'My Buyers' }
                        ]
                    },
                },
                {
                    path: '/app/buyers/:buyer_id',
                    name: 'buyers.show',
                    component: () => import('../screens/BuyerShowScreen.vue'),
                    meta: {
                        title: 'Buyer',
                        protected: true,
                    },
                },
                {
                    path: '/app/buyers/:buyer_id/update',
                    name: 'buyers.update',
                    component: () => import('../screens/BuyerUpdateScreen.vue'),
                    meta: {
                        title: 'Update Buyer',
                        protected: true,
                    },
                },
                /**********************************************************************
                 * Settings
                 **********************************************************************/
                {
                    path: '/app/settings/profile',
                    name: 'settings.profile',
                    component: () => import('../screens/SettingsUserScreen.vue'),
                    meta: {
                        title: 'My Profile',
                        protected: true,
                    }
                },
                {
                    path: '/app/settings/organisations',
                    name: 'settings.organisation.list',
                    component: () => import('../screens/SettingsOrganisationsScreen.vue'),
                    meta: {
                        title: 'My Organisations',
                        protected: true,
                    }
                },
                {
                    path: '/app/settings/organisations/:organisation_id?',
                    name: 'settings.organisation.show',
                    component: () => import('../screens/SettingsOrganisationScreen.vue'),
                    meta: {
                        title: 'Organisation',
                        protected: true,
                    }
                },
                {
                    path: '/app/settings/notifications',
                    name: 'settings.notifications',
                    component: () => import('../screens/SettingsNotificationsScreen.vue'),
                    meta: {
                        title: 'Notifications',
                        protected: true,
                    }
                },
                {
                    path: '/app/settings/auctioneers',
                    name: 'settings.auctioneers',
                    component: () => import('../screens/SettingsUserAuctioneersScreen.vue'),
                    meta: {
                        title: 'Auctioneers',
                        protected: true,
                    }
                },
                {
                    path: '/app/settings/accounts',
                    name: 'settings.accounts',
                    component: () => import('../screens/SettingsUserAccountsScreen.vue'),
                    meta: {
                        title: 'Accounts',
                        protected: true,
                    }
                },
                /**********************************************************************
                 * User Admin
                 **********************************************************************/
                {
                    path: '/app/admin/users',
                    name: 'superadmin.users',
                    component: () => import('../screens/SuperAdminUsersListScreen.vue'),
                    meta: {
                        title: 'Auction365 Users',
                        protected: true,
                        super_admin: true
                    }
                },
                {
                    path: '/app/admin/users/:user_id',
                    name: 'superadmin.users.edit',
                    component: () => import('../screens/SuperAdminUsersViewScreen.vue'),
                    meta: {
                        title: 'Manage User',
                        protected: true,
                        super_admin: true,
                        breadcrumbs: [
                            { name: 'superadmin.users', label: 'All Users' }
                        ]
                    }
                },
                {
                    path: '/app/admin/users/create',
                    name: 'superadmin.users.create',
                    component: () => import('../screens/SuperAdminUsersCreateScreen.vue'),
                    meta: {
                        title: 'New User',
                        protected: true,
                        super_admin: true,
                        breadcrumbs: [
                            { name: 'superadmin.users', label: 'All Users' }
                        ]
                    }
                },
                {
                    path: '/app/admin/invitations',
                    name: 'superadmin.invites',
                    component: () => import('../screens/SuperAdminInvitesListScreen.vue'),
                    meta: {
                        title: 'All Invitations',
                        protected: true,
                        super_admin: true
                    }
                },
                {
                    path: '/app/admin/invitations/create',
                    name: 'superadmin.invites.create',
                    component: () => import('../screens/SuperAdminInvitesCreateScreen.vue'),
                    meta: {
                        title: 'New Invitation',
                        protected: true,
                        super_admin: true,
                        breadcrumbs: [
                            { name: 'superadmin.invites', label: 'All Invitations' }
                        ]
                    }
                },
                {
                    path: '/app/admin/invitations/:invite_id',
                    name: 'superadmin.invites.show',
                    component: () => import('../screens/SuperAdminInvitesShowScreen.vue'),
                    meta: {
                        title: 'Invitations',
                        protected: true,
                        super_admin: true,
                        breadcrumbs: [
                            { name: 'superadmin.invites', label: 'All Invitations' }
                        ]
                    }
                },
                
                {
                    path: '/app/admin/organisations',
                    name: 'superadmin.organisations',
                    component: () => import('../screens/SuperAdminOrganisationsListScreen.vue'),
                    meta: {
                        title: 'Auction365 Organisations',
                        protected: true,
                        super_admin: true
                    }
                },
                {
                    path: '/app/admin/organisations/:organisation_id?',
                    name: 'superadmin.organisations.edit',
                    component: () => import('../screens/SuperAdminOrganisationsViewScreen.vue'),
                    meta: {
                        title: 'Manage Organisation',
                        protected: true,
                        super_admin: true
                    }
                },
                {
                    path: '/app/admin/organisations/create',
                    name: 'superadmin.organisations.create',
                    component: () => import('../screens/SuperAdminCreateOrganisationScreen.vue'),
                    meta: {
                        title: 'Auction365 New Organisations',
                        protected: true,
                        super_admin: true
                    }
                },
                {
                    path: '/app/admin/organisations/:organisation_id?/create',
                    name: 'superadmin.organisations.create-child',
                    component: () => import('../screens/SuperAdminCreateOrganisationScreen.vue'),
                    meta: {
                        title: 'Auction365 New Organisations',
                        protected: true,
                        super_admin: true
                    }
                },
                {
                    path: '/app/admin/analytics/sessions',
                    name: 'superadmin.analytics.sessions',
                    component: () => import('../screens/SuperAdminSessionExplorerScreen.vue'),
                    meta: {
                        title: 'Session Explorer',
                        protected: true,
                        super_admin: true
                    }
                },
                {
                    path: '/app/admin/analytics/sessions/:session_id',
                    name: 'superadmin.analytics.sessions.view',
                    component: () => import('../screens/SuperAdminSessionViewScreen.vue'),
                    meta: {
                        title: 'Session',
                        protected: true,
                        super_admin: true,
                        breadcrumbs: [
                            { name: 'superadmin.analytics.sessions', label: 'All Sessions' }
                        ],
                    }
                },
                {
                    path: '/app/admin/support',
                    name: 'superadmin.support.index',
                    component: () => import('../screens/SuperAdminSupportTicketsListScreen.vue'),
                    meta: {
                        title: 'Support Tickets',
                        protected: true,
                        super_admin: true,
                        breadcrumbs: [],
                    }
                },
                {
                    path: '/app/admin/support/:support_ticket_id',
                    name: 'superadmin.support.show',
                    component: () => import('../screens/SuperAdminSupportTicketsShowScreen.vue'),
                    meta: {
                        title: 'Support Ticket',
                        protected: true,
                        super_admin: true,
                        breadcrumbs: [
                            { name: 'superadmin.support.index', label: 'Support Tickets' }
                        ],
                    }
                },
                /**********************************************************************
                 * Reports
                 **********************************************************************/
                {
                    path: '/app/reports',
                    name: 'reports.index',
                    component: () => import('../screens/ReportOverviewScreen.vue'),
                    meta: {
                        title: 'Reports',
                        protected: true,
                        super_admin: false,
                    }
                },
                {
                    path: '/app/reports/sold-vehicles',
                    name: 'reports.sold-vehicles',
                    component: () => import('../screens/ReportsSoldVehiclesReportScreen.vue'),
                    meta: {
                        title: 'Sold Vehicles Report',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'reports.index', label: 'Reports' }
                        ],
                    }
                },
                {
                    path: '/app/reports/overview',
                    name: 'reports.overview',
                    component: () => import('../screens/ReportOverviewScreen.vue'),
                    meta: {
                        title: 'Overview',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'reports.index', label: 'Reports' }
                        ],
                    }
                },
                {
                    path: '/app/reports/sales',
                    name: 'reports.sale-results',
                    component: () => import('../screens/ReportSaleResultsScreen.vue'),
                    meta: {
                        title: 'Sale Results Report',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'reports.index', label: 'Reports' }
                        ],
                    }
                },
                {
                    path: '/app/reports/seller',
                    name: 'reports.vehicles-selling',
                    component: () => import('../screens/ReportsVehiclesSellingReport.vue'),
                    meta: {
                        title: 'Vehicles I\'m Selling',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [],
                    }
                },
                {
                    path: '/app/reports/lotnos',
                    name: 'reports.lotnos',
                    component: () => import('../screens/ReportsLotNoOverviewScreen.vue'),
                    meta: {
                        title: 'Lot Numbers Overview',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [],
                    }
                },
                {
                    path: '/app/reports/makes',
                    name: 'reports.breakdown-makes',
                    component: () => import('../screens/ReportBreakdownMakesScreen.vue'),
                    meta: {
                        title: 'Makes Report',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'reports.index', label: 'Reports' }
                        ],
                    }
                },
                {
                    path: '/app/reports/sale-price',
                    name: 'reports.breakdown-sale-price',
                    component: () => import('../screens/ReportBreakdownSalePriceScreen.vue'),
                    meta: {
                        title: 'Sale Price Report',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'reports.index', label: 'Reports' }
                        ],
                    }
                },
                {
                    path: '/app/reports/sold-by-seller',
                    name: 'reports.sold-by-seller',
                    component: () => import('../screens/ReportSoldBySellerScreen.vue'),
                    meta: {
                        title: 'Sold by Seller Report',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'reports.index', label: 'Reports' }
                        ],
                    }
                },
                /**********************************************************************
                 * Marketing
                 **********************************************************************/
                {
                    path: '/app/marketing',
                    name: 'marketing.index',
                    component: () => import('../screens/MarketingIndexScreen.vue'),
                    meta: {
                        title: 'Marketing',
                        protected: true,
                        super_admin: false,
                    }
                },
                {
                    path: '/app/marketing/prompt-test',
                    name: 'marketing.prompt-test',
                    component: () => import('../screens/MarketingTestAiPromptScreen.vue'),
                    meta: {
                        title: 'Prompt Test',
                        protected: true,
                        super_admin: false,
                    }
                },
                // templates
                {
                    path: '/app/marketing/templates',
                    name: 'marketing.templates.list',
                    component: () => import('../screens/MarketingTemplatesListScreen.vue'),
                    meta: {
                        title: 'Marketing Templates',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [],
                    }
                },
                {
                    path: '/app/marketing/templates/create',
                    name: 'marketing.templates.create',
                    component: () => import('../screens/MarketingTemplateCreateScreen.vue'),
                    meta: {
                        title: 'Create Marketing Template',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.templates.list', label: 'Marketing Templates' }
                        ],
                    }
                },
                {
                    path: '/app/marketing/templates/:template_id',
                    name: 'marketing.templates.view',
                    component: () => import('../screens/MarketingTemplateViewScreen.vue'),
                    meta: {
                        title: 'View Marketing Template',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.templates.list', label: 'Marketing Templates' }
                        ],
                    }
                },
                {
                    path: '/app/marketing/templates/:template_id/update',
                    name: 'marketing.templates.update',
                    component: () => import('../screens/MarketingTemplateUpdateScreen.vue'),
                    meta: {
                        title: 'Update Marketing Template',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.templates.list', label: 'Marketing Templates' }
                        ],
                    }
                },
                // campaigns
                {
                    path: '/app/marketing/campaigns',
                    name: 'marketing.campaigns.list',
                    component: () => import('../screens/MarketingCampaignsListScreen.vue'),
                    meta: {
                        title: 'Marketing Campaigns',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [],
                    }
                },
                {
                    path: '/app/marketing/campaigns/create',
                    name: 'marketing.campaigns.create',
                    component: () => import('../screens/MarketingCampaignCreateScreen.vue'),
                    meta: {
                        title: 'Create Marketing Campaign',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.campaigns.list', label: 'Marketing Campaigns' }
                        ],
                    }
                },
                {
                    path: '/app/marketing/campaigns/:campaign_id',
                    name: 'marketing.campaigns.view',
                    component: () => import('../screens/MarketingCampaignViewScreen.vue'),
                    meta: {
                        title: 'Marketing Campaign',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.campaigns.list', label: 'Marketing Campaigns' }
                        ],
                    }
                },
                {
                    path: '/app/marketing/campaigns/:campaign_id/update',
                    name: 'marketing.campaigns.update',
                    component: () => import('../screens/MarketingCampaignUpdateScreen.vue'),
                    meta: {
                        title: 'Update Marketing Campaign',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.campaigns.list', label: 'Marketing Campaigns' }
                        ],
                    }
                },
                // campaign emails
                {
                    path: '/app/marketing/campaigns/:campaign_id/emails',
                    name: 'marketing.campaigns.emails.list',
                    component: () => import('../screens/MarketingCampaignEmailsListScreen.vue'),
                    meta: {
                        title: 'Marketing Campaign Emails',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.campaigns.list', label: 'Marketing Campaigns' }
                        ],
                    }
                },
                {
                    path: '/app/marketing/campaigns/:campaign_id/emails/create',
                    name: 'marketing.campaigns.emails.create',
                    component: () => import('../screens/MarketingCampaignEmailCreateScreen.vue'),
                    meta: {
                        title: 'Create Marketing Campaign Email',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.campaigns.list', label: 'Marketing Campaigns' }
                        ],
                    }
                },
                {
                    path: '/app/marketing/campaigns/:campaign_id/emails/:email_id',
                    name: 'marketing.campaigns.emails.view',
                    component: () => import('../screens/MarketingCampaignEmailViewScreen.vue'),
                    meta: {
                        title: 'View Marketing Campaign Email',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.campaigns.list', label: 'Marketing Campaigns' }
                        ],
                    }
                },
                {
                    path: '/app/marketing/campaigns/:campaign_id/emails/:email_id/setup',
                    name: 'marketing.campaigns.emails.setup',
                    component: () => import('../screens/MarketingCampaignEmailSetupScreen.vue'),
                    meta: {
                        title: 'Setup Marketing Campaign Email',
                        protected: true,
                        super_admin: false
                    }
                },
                {
                    path: '/app/marketing/campaigns/:campaign_id/emails/:email_id/update',
                    name: 'marketing.campaigns.emails.update',
                    component: () => import('../screens/MarketingCampaignEmailUpdateScreen.vue'),
                    meta: {
                        title: 'Update Marketing Campaign Email',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'marketing.campaigns.list', label: 'Marketing Campaigns' }
                        ],
                    }
                },

                /**********************************************************************
                 * Support Ticket Screens
                 **********************************************************************/
                {
                    path: '/app/support',
                    name: 'support.index',
                    component: () => import('../screens/SupportTicketsIndexScreen.vue'),
                    meta: {
                        title: 'My Support Tickets',
                        protected: true,
                        super_admin: false
                    }
                },
                {
                    path: '/app/support/new-ticket',
                    name: 'support.create',
                    component: () => import('../screens/SupportTicketsCreateScreen.vue'),
                    meta: {
                        title: 'Log a Support Ticket',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: [
                            { name: 'support.index', label: 'My Support Tickets' }
                        ],
                    }
                },
                {
                    path: '/app/support/:support_ticket_id',
                    name: 'support.show',
                    component: () => import('../screens/SupportTicketsShowScreen.vue'),
                    meta: {
                        title: 'Support Ticket',
                        protected: true,
                        super_admin: false,
                        breadcrumbs: null,
                    }
                },
                /**********************************************************************
                 * Splash Screens
                 **********************************************************************/
                 {
                    path: '/app/forbidden',
                    name: 'splash.forbidden',
                    component: () => import('../screens/SplashForbiddenScreen.vue'),
                    meta: {
                        title: 'Forbidden',
                        protected: true,
                    }
                },
                
            ]
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'error.not-found',
            component: () => import('../screens/404.vue'),
        }
    ]
})

/**
 * take the current path and store it in sessionStorage
 */
const storeTargetPath = full_path => {
    if (typeof full_path == 'string' && full_path.length > 0) sessionStorage.setItem('@A_TARGET_PATH', full_path)
}

// These events fire before each navigation event initialises
router.beforeEach(async (to, from) => {

    // allow public routes to be accessed unhindered
    if (!to?.meta?.protected) return

    const AUTH = useAuthStore()
    // have the auth store run an auth check which returns a bool value
    const authenticated = await AUTH.authCheck()
    // if we're unauthorised redirect to login
    if (!authenticated) {
        storeTargetPath(to?.fullPath)
        //SYSTEM_STORE.clear()
        return '/login'
    }

    // super admin routes
    if (to?.meta?.super_admin && (!Array.isArray(AUTH.user?.roles) || !AUTH.user?.roles.includes('USER_SUPER_ADMIN'))) {
        return '/app/forbidden'
    }

});

router.afterEach((to, from) => {

    const COMMENT_STORE = useCommentStore()
    COMMENT_STORE.resetStore()

    const AUTH_STORE = useAuthStore()
    AUTH_STORE.afterNavigationEvent()

});